import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { OperationEntityConfigurationAddEdit, OperationEntityConfiguration } from './Pages'

export const OperationEntityConfigurationRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={OperationEntityConfiguration} />
        <Route exact path = {`${match.path}/AddEdit`} component={OperationEntityConfigurationAddEdit} />
    </Fragment>
)